'use client'
import { InfoNoIcon, InfoSuccessIcon } from '../../../icons'
import React from 'react'
import { Spinner } from '../../../atoms'
import { ToastVariant } from '../../../../types'

export const getToastIcon = (variant?: ToastVariant): JSX.Element | null => {
    switch (variant) {
        case ToastVariant.LOADING:
            return <Spinner />
        case ToastVariant.ERROR:
            return <InfoNoIcon />
        case ToastVariant.SUCCESS:
            return <InfoSuccessIcon />
        default:
            return null
    }
}
